(function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.nav-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product thumbnail swapping
  var main = document.getElementById('ProductMainImg');
  document.querySelectorAll('.thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!main) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = btn.dataset.large;
      main.alt = btn.dataset.alt || main.alt;
      document.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // Variant price update
  var sel = document.getElementById('VariantSelect');
  var price = document.getElementById('ProductPrice');
  var compare = document.getElementById('ProductCompare');
  if (sel && price) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      if (opt.dataset.price) price.textContent = opt.dataset.price;
      if (compare) {
        var c = opt.dataset.compare || '';
        compare.textContent = c;
        compare.hidden = !c;
        price.classList.toggle('sale', !!c);
      }
    });
  }
})();
